document.addEventListener('click', (e) => {
    const link = e.target.closest('a')
    if (!link) return

    const href = link.getAttribute('href')
    if (!href || href.length < 2 || !href.startsWith('#')) return

    e.preventDefault()

    const targetId = href.substring(1)
    const target = document.getElementById(targetId)
    if (!target) return

    const headerOffset = parseInt(link.getAttribute('data-offset')) || 130
    const targetPosition = target.getBoundingClientRect().top + window.scrollY
    const offsetPosition = targetPosition - headerOffset

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
    })
})
